module.exports = __webpack_public_path__ + "img/user.4d9542df.svg";